var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"analysisReport-box"},[_c('analysisReport',{ref:"analysisReport"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }